import { useParams } from 'react-router-dom';
import { EntryPageTemplate } from '#/guest-aps/templates/entry-page-template';
import { useParkinglotByCode } from '#/guest-aps/services/use-parkinglot-by-code';
import { useAmplitudeOpenFromLink } from '#/guest-aps/hooks/use-amplitude-open-from-link';

export const SerialCodeEntryPage = () => {
  const { parkinglotCode, serialCode } = useParams();
  const { parkinglot, metadata, getParkinglotFromCodeStatus } =
    useParkinglotByCode({
      parkinglotCode,
      serialCode,
    });

  useAmplitudeOpenFromLink(
    metadata
      ? {
          url: window.location.href,
          source: metadata.scan_source,
          code: metadata.serial_number,
          name: metadata.name,
        }
      : null,
  );

  return (
    <EntryPageTemplate
      parkinglot={parkinglot}
      isParkinglotFetched={getParkinglotFromCodeStatus === 'success'}
    />
  );
};
